import { TextInput } from '@core/components/Inputs';
import { SelectInput, SelectSimple } from '@core/components/Select';
import { Divider, Grid, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';
import ClienteDadosGeraisEmpresaEstrangeira from './ClienteDadosGeraisEmpresaEstrangeira';
import ClienteDadosGeraisPessoaFisica from './ClienteDadosGeraisPessoaFisica';
import ClienteDadosGeraisPessoaJuridica from './ClienteDadosGeraisPessoaJuridica';

const TabDadosGeraisCliente = ({ onChangeTipoPessoa, fetchPapel }) => {
  const formik = useFormikContext();

  const _errors = {
    codigoCliente: (formik.touched?.codigoCliente || formik.submitCount > 0) && formik.errors.codigoCliente,
    pessoa: {
      nome: (formik.touched?.pessoa?.nome || formik.submitCount > 0) && formik.errors.pessoa?.nome,
      inscricaoMunicipal: formik.errors.pessoa?.inscricaoMunicipal,
      pessoaFisica: {
        dataNascimento: null,
        cpf: formik.errors.pessoa?.pessoaFisica?.cpf,
        identidade: formik.errors.pessoa?.pessoaFisica?.identidade,
      },
      pessoaJuridica: {
        cnpj: formik.errors.pessoa?.pessoaJuridica?.cnpj,
        razaoSocial: formik.errors.pessoa?.pessoaJuridica?.razaoSocial,
        inscricaoEstadual: formik.errors.pessoa?.pessoaJuridica?.inscricaoEstadual,
      },
      empresaEstrangeira: {
        identificadorEstrangeiro: formik.errors.pessoa?.empresaEstrangeira?.identificadorEstrangeiro,
      },
    },
    contribuinteIbs: (formik.touched?.contribuinteIbs || formik.submitCount > 0) && formik.errors?.contribuinteIbs,
    contribuinteCbs: (formik.touched?.contribuinteCbs || formik.submitCount > 0) && formik.errors?.contribuinteCbs,
  };

  const removerCodigoPais = (tipoPessoa) => {
    if (tipoPessoa === 'FISICA' || tipoPessoa === 'JURIDICA') {
      return formik.values.pessoa?.contatos?.[0]?.telefonesAdicionais?.forEach((telefone) => {
        telefone.codigoPais = null;
      });
    }
  };

  const handleChangeTipoPessoa = (event) => {
    formik.handleChange(event);
    onChangeTipoPessoa(event.target.value);
    removerCodigoPais(event.target.value);
  };

  const alphaNumericRegex = /^[a-z0-9]+$/i;
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
        <TextInput
          id="pessoa.nome"
          name="pessoa.nome"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.pessoa.nome}
          error={_errors.pessoa.nome}
          touched={formik.touched.pessoa?.nome}
          required
          fullWidth
          autoFocus
          variant="outlined"
          label="Nome"
          maxLength={100}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <TextInput
          id="codigoCliente"
          name="codigoCliente"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.codigoCliente}
          error={_errors.codigoCliente}
          touched={formik.touched.codigoCliente}
          pattern={alphaNumericRegex}
          fullWidth
          variant="outlined"
          label="Código do cliente"
          maxLength={5}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SelectSimple
          defaultValue="JURIDICA"
          label="Tipo de pessoa"
          id="pessoa.tipoPessoa"
          onChange={handleChangeTipoPessoa}
          value={formik.values.pessoa.tipoPessoa}
          options={[
            { title: 'Pessoa Jurídica', id: 'JURIDICA' },
            { title: 'Pessoa Física', id: 'FISICA' },
            { title: 'Empresa Estrangeira', id: 'ESTRANGEIRA' },
          ]}
          disabled={formik.values.possuiVinculo}
        />
      </Grid>

      {formik.values.pessoa.tipoPessoa === 'FISICA' && (
        <ClienteDadosGeraisPessoaFisica
          id="pessoa.pessoaFisica"
          name="pessoa.pessoaFisica"
          values={{
            pessoaFisica: formik.values.pessoa.pessoaFisica,
            inscricaoMunicipal: formik.values?.pessoa?.inscricaoMunicipal,
          }}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          touched={formik.touched.pessoa}
          errors={_errors.pessoa}
          fetchPapel={fetchPapel}
          possuiVinculo={formik.values.possuiVinculo}
        />
      )}

      {formik.values.pessoa.tipoPessoa === 'JURIDICA' && (
        <ClienteDadosGeraisPessoaJuridica
          id="pessoa.pessoaJuridica"
          name="pessoa.pessoaJuridica"
          values={{
            pessoaJuridica: formik.values.pessoa?.pessoaJuridica,
            principalAtividadeEconomica: formik.values.principalAtividadeEconomica,
            optanteSimples: formik.values?.optanteSimples,
            inscricaoMunicipal: formik.values?.pessoa?.inscricaoMunicipal,
          }}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          touched={formik.touched.pessoa}
          errors={_errors.pessoa}
          fetchPapel={fetchPapel}
          possuiVinculo={formik.values.possuiVinculo}
        />
      )}

      {formik.values.pessoa.tipoPessoa === 'ESTRANGEIRA' && (
        <ClienteDadosGeraisEmpresaEstrangeira
          id="pessoa.empresaEstrangeira"
          values={formik.values.pessoa?.empresaEstrangeira}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          touched={formik.touched.pessoa?.empresaEstrangeira}
          errors={_errors.pessoa?.empresaEstrangeira}
        />
      )}

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="observacoes"
          name="observacoes"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.observacoes}
          error={formik.errors.observacoes}
          touched={formik.touched.observacoes}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          label="Observações"
          maxLength={255}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" style={{ fontWeight: 'bold' }}>
          Reforma Tributária
        </Typography>
        <Divider />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SelectInput
          id="contribuinteIbs"
          value={formik.values?.contribuinteIbs}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Contribuinte IBS"
          options={[
            { id: true, title: 'Sim' },
            { id: false, title: 'Não' },
          ]}
          required
          touched={!!_errors.contribuinteIbs}
          error={_errors.contribuinteIbs}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SelectInput
          id="contribuinteCbs"
          value={formik.values?.contribuinteCbs}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Contribuinte CBS"
          options={[
            { id: true, title: 'Sim' },
            { id: false, title: 'Não' },
          ]}
          required
          touched={!!_errors.contribuinteCbs}
          error={_errors.contribuinteCbs}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <SelectInput
          id="tipoIndicadorOperacao"
          value={formik.values?.tipoIndicadorOperacao}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Indicador de operação"
          options={[
            { id: 'NAO_APLICA', title: '0 - Não se aplica' },
            { id: 'INTERNA', title: '1 - Interna' },
            { id: 'INTERESTADUAL', title: '2 - Interestadual' },
            { id: 'EXTERIOR', title: '3 - Exterior' },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default TabDadosGeraisCliente;
